import IconProfile from 'components/icons/profile';

export const NAV_LINK_ACCOUNT_ICON_COMPONENT = IconProfile;

export const NAV_BAR_ICON_SIZE = 20;
